import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import EditableSection from '../../components/EditableSection';

import DoorsEditor from '../DoorsEditor';
import HolesEditor from '../HolesEditor';
import WindowsEditor from '../WindowsEditor';
import { EditorsWrapper } from './ConstructionExtras.styles';
import PlexiWindowsEditor from '../PlexiWindowsEditor';
import ShutterWindowsEditor from '../ShutterWindowsEditor';
import Roofing from '../Roofing';
import { useTranslation } from "../../contexts/TranslationContext";
import { AppstoreOutlined } from "@ant-design/icons";

import { setUiOpenSection, clearUiScrollTarget } from '../Construction/construction.reducer';

const ConstructionExtras = ({ collapsed, translationsData = useTranslation() }) => {
  const dispatch = useDispatch();

  const openSections = useSelector((state) => state?.Construction?.openSections || {});
  const isOpen = openSections.constructionExtras ?? true; // ✅ na start true

  const scrollTargetId = useSelector((state) => state?.Construction?.scrollTargetId);
  React.useEffect(() => {
    if (scrollTargetId !== 'doorsEditor') return;

    // ✅ otwórz ConstructionExtras i DoorsEditor
    dispatch(setUiOpenSection('constructionExtras', true));
    dispatch(setUiOpenSection('doors', true));

    const tryScroll = (tries = 20) => {
      const el = document.getElementById('doorsEditor');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        dispatch(clearUiScrollTarget());
        return;
      }
      if (tries > 0) setTimeout(() => tryScroll(tries - 1), 50);
      else dispatch(clearUiScrollTarget());
    };
    setTimeout(() => tryScroll(), 0);
  }, [scrollTargetId, dispatch]);

  return (
    <EditableSection
      collapsed={collapsed}
      icon={<AppstoreOutlined />}
      title={translationsData.construction_additives || 'construction_additives'}
      open={isOpen}
    >
      <EditorsWrapper>
        {/* ✅ id w DOM do scrolla */}
        <div id="doorsEditor">
          <DoorsEditor collapsed={collapsed} />
        </div>

        <HolesEditor collapsed={collapsed} />
        <ShutterWindowsEditor collapsed={collapsed} />
        <WindowsEditor collapsed={collapsed} />
        <PlexiWindowsEditor collapsed={collapsed} />
        <Roofing collapsed={collapsed} />
      </EditorsWrapper>
    </EditableSection>
  );
};

ConstructionExtras.propTypes = {
  collapsed: PropTypes.bool.isRequired
};

export default ConstructionExtras;
